/**
 * @generated SignedSource<<4fc407496912e8a510d438293f8da28c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type projectNotificationsAccordion_personalSettingsNotificationsConfigTable$data = {
  readonly avatar: {
    readonly xsmall: string;
  };
  readonly id: string;
  readonly name: string;
  readonly " $fragmentType": "projectNotificationsAccordion_personalSettingsNotificationsConfigTable";
};
export type projectNotificationsAccordion_personalSettingsNotificationsConfigTable$key = {
  readonly " $data"?: projectNotificationsAccordion_personalSettingsNotificationsConfigTable$data;
  readonly " $fragmentSpreads": FragmentRefs<"projectNotificationsAccordion_personalSettingsNotificationsConfigTable">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "projectNotificationsAccordion_personalSettingsNotificationsConfigTable",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "id"
      },
      "action": "THROW",
      "path": "id"
    },
    {
      "kind": "RequiredField",
      "field": {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
          {
            "kind": "RequiredField",
            "field": {
              "kind": "ScalarField",
              "name": "xsmall"
            },
            "action": "THROW",
            "path": "avatar.xsmall"
          }
        ]
      },
      "action": "THROW",
      "path": "avatar"
    },
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "name"
      },
      "action": "THROW",
      "path": "name"
    }
  ],
  "type": "JiraProject"
};

(node as any).hash = "dfd510bee0fd10776f8f0d1854818db2";

export default node;
